import { gateway } from "../../../gateway";

export const acceptQuoteById = async (id, patchData = {}) => {
  try {
    const params = new URLSearchParams(window.location.search);
    const tokenFromParams = params.get("token");
    const tokenFromLocal = sessionStorage.getItem("token");

    const token = tokenFromParams || tokenFromLocal;

    if (!token) {
      throw new Error("No token provided");
    }

    const isFormData = patchData instanceof FormData;

    const res = await gateway.patch(`/quotes/self/${id}`, patchData, {
      headers: {
        Authorization: token,
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
      },
    });

    return res.data;
  } catch (error) {
    throw error;
  }
};
